<template>
	<div class="w-full border-b" data-slot="navigation-menu-separator" />
</template>
